import React from 'react';
import { MapPin } from 'lucide-react';
import heroBg from '../assets/optimized/hero-bg.webp';

const Hero = () => {
    return (
        <section
            id="hero"
            className="relative min-h-screen flex items-center justify-center overflow-hidden bg-coffee-900"
        >
            {/* Optimized Background Image for LCP */}
            <div className="absolute inset-0 z-0">
                <img
                    src={heroBg}
                    alt=""
                    className="w-full h-full object-cover opacity-40 blur-[2px]"
                    fetchpriority="high"
                    loading="eager"
                    decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-coffee-900/60 via-transparent to-coffee-900/40"></div>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center relative z-10">
                {/* Main Headline */}
                <div className="animate-fade-in">
                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold text-cream mb-4 leading-tight">
                        Healthy Massage at Home
                        <br />
                        <span className="text-zen-gold">Home Service Bengaluru</span>
                    </h1>

                    <p className="text-2xl md:text-3xl text-zen-gold/90 mb-6 font-display">
                        Full Body Massage | Ayurvedic & Spa Therapy
                    </p>

                    <p className="text-xl md:text-2xl text-cream/90 mb-10 max-w-3xl mx-auto font-light">
                        <span className="text-zen-gold font-semibold">Male-to-Male & Male-to-Female Service Only</span>
                        <br />
                        <span className="text-cream/70 text-base">(Only Male Therapist Available – No Female Therapist)</span>
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex justify-center items-center">
                        <button
                            onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                            className="bg-zen-gold text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-coffee-900 transition-all duration-300 shadow-premium hover:shadow-glow flex items-center space-x-2"
                        >
                            <span>View Services</span>
                        </button>
                    </div>

                    {/* Location Badge */}
                    <div className="mt-12 inline-flex items-center glass px-6 py-3 rounded-full flex-wrap justify-center text-center">
                        <MapPin className="text-zen-gold mr-2" size={18} />
                        <span className="text-cream">
                            Serving <span className="text-zen-gold font-semibold">J.P. Nagar & All Bengaluru</span> (Homes, Hotels, Rooms & Resorts)
                        </span>
                    </div>
                </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cream to-transparent"></div>
        </section>
    );
};

export default Hero;
